import { render } from "./AddDriverPage.vue?vue&type=template&id=fb6f78b4&scoped=true"
import script from "./AddDriverPage.vue?vue&type=script&lang=js"
export * from "./AddDriverPage.vue?vue&type=script&lang=js"

import "./AddDriverPage.vue?vue&type=style&index=0&id=fb6f78b4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6f78b4"]])

export default __exports__